"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CourseType = 'course';
exports.SectionType = 'section';
exports.QuizType = 'quiz';
exports.ExamType = 'exam';
exports.PracticeType = 'practice';
//# sourceMappingURL=types.js.map